import React from 'react';
import { Forms, Modal, SaveButton, StringHelpers, SystemText } from 'e4shared';
import { useDispatch, useSelector } from 'react-redux';
import { setShowSuccess, showWidgetConfig, toggleFormHelp } from 'actions/ui';
import { widgets } from 'data/widgets';
import { apiDelete, apiPatch } from 'services';

export const Filters = ({ validator, show, refresh, widget, values, errors, onChange, children, onDelete }) => {
    if (!values) return null;

    const dispatch = useDispatch();
    const [saving, setSaving] = React.useState(false);

    const user = useSelector(state => state.user.user);

    const save = () => {
        if (validator()) {
            const item = {
                ...widget,
                name: values.name,
                data: JSON.stringify(values),
            };

            apiPatch('widget', item, user.guid, () => {
                refresh?.(item);
                dispatch(setShowSuccess(SystemText('Dashboard/Widget/General/Edit/Success')));
                close();
            });
        } else {
            setSaving(false);
        }
    };

    const deleteWidget = () => {
        apiDelete(`widget/${widget.id}`, null, user.guid, () => {
            onDelete(widget.id);
            close();
        });
    };

    const close = () => {
        setSaving(false);
        dispatch(showWidgetConfig(null));
    };

    const footer = (
        <div className="flex clex-center">
            <div className="flex-grow text-left">
                <button data-testid="widget-delete-button" className="btn btn-danger" onClick={deleteWidget}>
                    <i className="fa fa-trash mr10" />
                    {SystemText('Dashboard/Widget/General/Edit/Buttons/Delete')}
                </button>
            </div>
            <div>
                <SaveButton
                    data-testid="widget-save-button"
                    id="widget-save-button"
                    saving={saving}
                    setSaving={setSaving}
                    className="btn btn-success"
                    onClick={save}
                >
                    {SystemText('Dashboard/Widget/General/Edit/Buttons/Save')}
                </SaveButton>
                <button data-testid="widget-close-button" className="btn" onClick={close}>
                    {SystemText('Dashboard/Widget/General/Edit/Buttons/Close')}
                </button>
            </div>
        </div>
    );

    const baseWidget = widgets.find(w => w.widget === widget.widget) || { widget: 'unknown' };
    baseWidget.name = SystemText(`Dashboard/Widgets/${StringHelpers.capitalise(baseWidget.widget)}/Title`);

    return (
        <Modal
            show={show}
            close={close}
            footer={footer}
            title={`${SystemText('Dashboard/Widget/General/Edit/Title')} - ${baseWidget ? baseWidget.name : 'Deprecated'}`}
            toggleFormHelp={() => dispatch(toggleFormHelp())}
        >
            <div className="form-group">
                <Forms.Text
                    type="text"
                    label={SystemText('Dashboard/Widgets/General/Edit/Fields/Name/Label')}
                    mandatory
                    value={values.name}
                    error={errors.name}
                    onChange={value => onChange(value, 'name')}
                    maxLength="50"
                    data-testid="text-widget-name"
                    placeholder={SystemText('Dashboard/Widgets/General/Edit/Fields/Name/Placeholder')}
                    help={SystemText('Dashboard/Widgets/General/Edit/Fields/Name/Help')}
                />
                {children}
            </div>
            {!user.administrator && (
                <div className="text-sm flex flex-center">
                    <i className="fa fa-warning text-warning mr10" />
                    <span>{SystemText('Dashboard/Widgets/General/Edit/Downline')}</span>
                </div>
            )}
        </Modal>
    );
};

export default Filters;
